import type { JSX, ParentComponent } from "solid-js";
import "./InputContainer.css";

type Props = {
	class?: string;
	style?: JSX.CSSProperties;
	/** If true, the input & input container will grow to fill the available space. */
	grow?: boolean;
	size?: "small" | "medium" | "large";
};
/**
 * Wrapper for form input fields with consistent styling.
 *
 * [Design System →](http://localhost:5174/component/Form%20Controls)
 */
export const InputContainer: ParentComponent<Props> = (props) => {
	return (
		<div
			classList={{
				"gvtui-input-container": true,
				"gvtui-input-container--grow": props.grow ?? false,
				"gvtui-input-container--size-small": props.size === "small",
				"gvtui-input-container--size-large": props.size === "large",
			}}
			class={props.class ?? ""}
			style={props.style}
		>
			{props.children}
		</div>
	);
};
